"use client";

import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from "react";
import { useTenant } from "@/contexts/tenant-provider";
import { formatDoseComponentAmount, getDoseComponentName, getDoseComponents } from "@/lib/dose-components";
import { formatDate, formatName, formatStaffName, toClinicDateKey } from "@/lib/format-data";
import { MedicationSummary } from "@/types/medication";
import { PatientSummary } from "@/types/patient";
interface PrescriptionFormProps {
  medication: MedicationSummary;
  patient: PatientSummary;
}
export const PrescriptionForm = forwardRef<HTMLDivElement, PrescriptionFormProps>((t0, ref) => {
  const $ = _c(85);
  const {
    medication,
    patient
  } = t0;
  const {
    tenant
  } = useTenant();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  React.useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: "Arial, sans-serif",
      fontSize: "12px",
      lineHeight: "1.4"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tenant) {
    t3 = tenant?.logoUrl && <div className="mb-4"><img src={tenant.logoUrl} alt={`${tenant.name} logo`} className="h-16 w-auto object-contain" style={{
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        height: "64px",
        width: "auto"
      }} /></div>;
    $[2] = tenant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h1 className="mb-1 text-h3">Wellness by ApproXie</h1>;
    t5 = <p className="mb-1">2903 Wall Triana HWY Suite 6</p>;
    t6 = <p className="mb-1">Huntsville, AL 35824</p>;
    t7 = <p className="mb-4">Phone: (256) 808-9447</p>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3) {
    t8 = <div className="mb-6 text-center">{t3}{t4}{t5}{t6}{t7}</div>;
    $[8] = t3;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="text-left"><p className="font-medium">Nemil Shah, M.D.</p><p>DEA: FS4609915</p><p>LIC: 33227</p><p>NPI: 1760941740</p></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== medication.provider) {
    t10 = medication.provider ? formatStaffName(medication.provider) : "Provider not specified";
    $[11] = medication.provider;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <span>{t10}</span>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  bb0: {
    const firstName = medication.provider?.firstName?.toLowerCase() || "";
    if (["haven", "paige", "heather", "tyneishia", "tiffiney"].some(n => firstName.includes(n))) {
      t12 = ", CRNP";
      break bb0;
    }
    t12 = ", Medical Assistant";
  }
  let t13;
  if ($[15] !== t11 || $[16] !== t12) {
    t13 = <p className="font-medium">{t11}{t12}</p>;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  bb1: {
    const firstName_0 = medication.provider?.firstName?.toLowerCase() || "";
    if (firstName_0.includes("haven")) {
      t14 = "1-157639";
      break bb1;
    }
    if (firstName_0.includes("tyneishia")) {
      t14 = "1-115157";
      break bb1;
    }
    if (firstName_0.includes("heather")) {
      t14 = "1-143484";
      break bb1;
    }
    if (firstName_0.includes("paige")) {
      t14 = "1-142419";
      break bb1;
    }
    if (firstName_0.includes("tiffiney")) {
      t14 = "1-190049";
      break bb1;
    }
    t14 = "";
  }
  let t15;
  if ($[18] !== t14) {
    t15 = <p>LIC:{" "}{t14}</p>;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  bb2: {
    const firstName_1 = medication.provider?.firstName?.toLowerCase() || "";
    if (firstName_1.includes("haven")) {
      t16 = "1316541287";
      break bb2;
    }
    if (firstName_1.includes("paige")) {
      t16 = "1659906980";
      break bb2;
    }
    if (firstName_1.includes("heather")) {
      t16 = "1902310931";
      break bb2;
    }
    if (firstName_1.includes("tyneishia")) {
      t16 = "1235788415";
      break bb2;
    }
    if (firstName_1.includes("tiffiney")) {
      t16 = "1720319825";
      break bb2;
    }
    t16 = "No NPI Available";
  }
  let t17;
  if ($[20] !== t16) {
    t17 = <p>NPI:{" "}{t16}</p>;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t13 || $[23] !== t15 || $[24] !== t17) {
    t18 = <div className="mb-6 flex justify-between">{t9}<div className="text-right">{t13}{t15}{t17}</div></div>;
    $[22] = t13;
    $[23] = t15;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== medication.doseDate) {
    t19 = formatDate(toClinicDateKey(medication.doseDate ?? new Date()), {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    $[26] = medication.doseDate;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t19) {
    t20 = <div className="mb-6 border-b border-t py-2 text-center"><div className="flex justify-center"><span>Date:{" "}{t19}</span></div></div>;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h3 className="mb-2 font-bold">Patient Information:</h3>;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <strong>Patient Name:</strong>;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== patient.firstName || $[33] !== patient.lastName) {
    t23 = formatName(patient.firstName, patient.lastName).toUpperCase();
    $[32] = patient.firstName;
    $[33] = patient.lastName;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t23) {
    t24 = <p>{t22}{" "}{t23}</p>;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <strong>Patient Address:</strong>;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== patient.address || $[39] !== patient.addressLineTwo || $[40] !== patient.city || $[41] !== patient.state || $[42] !== patient.zipCode) {
    t26 = patient.address || patient.city || patient.state || patient.zipCode ? `${patient.address || ""}${patient.addressLineTwo ? ` ${patient.addressLineTwo}` : ""} ${patient.city || ""}, ${patient.state || ""} ${patient.zipCode || ""}`.trim().toUpperCase() : "ADDRESS NOT PROVIDED";
    $[38] = patient.address;
    $[39] = patient.addressLineTwo;
    $[40] = patient.city;
    $[41] = patient.state;
    $[42] = patient.zipCode;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t26) {
    t27 = <p>{t25}{" "}<span>{t26}</span></p>;
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== t24 || $[47] !== t27) {
    t28 = <div>{t24}{t27}</div>;
    $[46] = t24;
    $[47] = t27;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <strong>DOB:</strong>;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== patient.dateOfBirth) {
    t30 = patient.dateOfBirth ? formatDate(patient.dateOfBirth, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }) : "Not provided";
    $[50] = patient.dateOfBirth;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t30) {
    t31 = <div><p>{t29}{" "}<span>{t30}</span></p></div>;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t28 || $[55] !== t31) {
    t32 = <div className="mb-6">{t21}<div className="flex justify-between">{t28}{t31}</div></div>;
    $[54] = t28;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <h3 className="mb-2 font-bold">Dose Components:</h3>;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] !== medication) {
    t34 = getDoseComponents(medication).map(_temp2);
    $[58] = medication;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== t34) {
    t35 = <div className="mb-2 space-y-1">{t34}</div>;
    $[60] = t34;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <p className="mb-2"><strong>Refills:</strong> 0</p>;
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <strong>Directions:</strong>;
    $[63] = t37;
  } else {
    t37 = $[63];
  }
  const t38 = medication.comment || "TAKE AS DIRECTED";
  let t39;
  if ($[64] !== t38) {
    t39 = <span>{t38}</span>;
    $[64] = t38;
    $[65] = t39;
  } else {
    t39 = $[65];
  }
  let t40;
  if ($[66] !== medication.frequency) {
    t40 = medication.frequency && ` - ${medication.frequency.toUpperCase()}`;
    $[66] = medication.frequency;
    $[67] = t40;
  } else {
    t40 = $[67];
  }
  let t41;
  if ($[68] !== t40) {
    t41 = <span>{t40}</span>;
    $[68] = t40;
    $[69] = t41;
  } else {
    t41 = $[69];
  }
  let t42;
  if ($[70] !== t39 || $[71] !== t41) {
    t42 = <div className="mb-2">{t37}<p className="mt-1 uppercase">{t39}{t41}</p></div>;
    $[70] = t39;
    $[71] = t41;
    $[72] = t42;
  } else {
    t42 = $[72];
  }
  let t43;
  if ($[73] !== t35 || $[74] !== t42) {
    t43 = <div className="mb-8">{t33}{t35}{t36}{t42}</div>;
    $[73] = t35;
    $[74] = t42;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="text-left"><div className="mb-2 w-64 border-b pb-1" /><span className="text-body">Product Selection Permitted</span></div>;
    $[76] = t44;
  } else {
    t44 = $[76];
  }
  let t45;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="mt-12 pt-8"><div className="flex justify-between">{t44}<div className="text-right"><div className="mb-2 w-64 border-b pb-1" /><span className="text-body">Dispense as Written</span></div></div></div>;
    $[77] = t45;
  } else {
    t45 = $[77];
  }
  let t46;
  if ($[78] !== ref || $[79] !== t18 || $[80] !== t20 || $[81] !== t32 || $[82] !== t43 || $[83] !== t8) {
    t46 = <div ref={ref} className="mx-auto max-w-2xl  p-8 text-black" style={t2}>{t8}{t18}{t20}{t32}{t43}{t45}</div>;
    $[78] = ref;
    $[79] = t18;
    $[80] = t20;
    $[81] = t32;
    $[82] = t43;
    $[83] = t8;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  return t46;
});
PrescriptionForm.displayName = "PrescriptionForm";
function _temp() {
  const style = document.createElement("style");
  style.textContent = "\n      @media print {\n        .mb-4.flex.justify-center {\n          display: flex !important;\n          justify-content: center !important;\n          align-items: center !important;\n          text-align: center !important;\n          width: 100% !important;\n        }\n        .mb-4.flex.justify-center img {\n          display: block !important;\n          -webkit-print-color-adjust: exact !important;\n          color-adjust: exact !important;\n          print-color-adjust: exact !important;\n          height: 24px !important;\n          width: auto !important;\n          margin: 0 auto !important;\n          text-align: center !important;\n        }\n        .text-center {\n          text-align: center !important;\n        }\n        .mb-6.text-center {\n          text-align: center !important;\n          display: block !important;\n        }\n      }\n    ";
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}
function _temp2(component, index) {
  return <p key={component.id ?? `${component.name}-${index}`}><strong>{getDoseComponentName(component)}</strong> —{" "}{formatDoseComponentAmount(component)}</p>;
}